import { render, staticRenderFns } from "./SalesCrmTodos.vue?vue&type=template&id=577baa38&scoped=true&"
import script from "./SalesCrmTodos.vue?vue&type=script&lang=js&"
export * from "./SalesCrmTodos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577baa38",
  null
  
)

export default component.exports